import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { defineMessages } from 'react-intl';
import { Field } from 'redux-form';
import { intlMessage, reduxFormPropTypes } from 'constants/propTypes';
import { Card, CardTitle } from 'components/Card';
// This absolute import fixes a circular dependency
import CharactersRemaining from 'components/Form/CharactersRemaining/CharactersRemaining';
import Message from 'components/Message';
import Input from '../Input/Input';
import './EditSection.scss';

// TODO: fix - features/VenuePage/ClassScheduleDetails uses EditSection classNames (but not the component)

export const messages = defineMessages({
  charactersRemaining: {
    id: 'edit-section.characters-remaining',
    defaultMessage: '{remaining, plural, one {# character} other {# characters}} remaining',
  },
});

const EditSection = forwardRef(
  ({ input, meta, title, badge, explanation, FieldComponent, type, className, children, ...restProps }, ref) => {
    const { value } = input;
    const { maxLength } = restProps;

    return (
      <Card ref={ref} className={classNames('edit-section', className)}>
        <CardTitle collapsed>
          <Message message={title} />
          {badge}
        </CardTitle>
        {explanation && <Message as="p" className="text--light" message={explanation} />}
        <FieldComponent input={input} type={type} meta={meta} className="mb-s" {...restProps} />
        {(maxLength || children) && (
          <div className="edit-section__meta mt-0">
            {maxLength && <CharactersRemaining length={maxLength} value={value} />}
            {children}
          </div>
        )}
      </Card>
    );
  }
);

EditSection.propTypes = {
  badge: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  component: PropTypes.elementType,
  type: PropTypes.string,
  explanation: intlMessage,
  FieldComponent: PropTypes.elementType,
  title: intlMessage,
  ...reduxFormPropTypes.field,
};

EditSection.displayName = 'EditSection';

const EditSectionWrapper = forwardRef(({ component = Input, type = 'textarea', fieldName, ...restProps }, ref) => (
  <Field
    ref={ref}
    name={fieldName}
    component={EditSection}
    FieldComponent={component}
    type={type}
    {...restProps}
    forwardRef
  />
));

EditSectionWrapper.propTypes = {
  component: PropTypes.elementType,
  fieldName: PropTypes.string,
  type: PropTypes.string,
};

EditSectionWrapper.displayName = 'EditSectionWrapper';

export default EditSectionWrapper;
